<template>
  <section>
    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="10000"
      multi-line
      left
      top
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>

      <v-alert
        :value="err"
        type="error"
        v-if="err"
      >
        {{ err.graphQLErrors.length > 0 ? err.graphQLErrors[0].data.message : err.message }}
      </v-alert>
      <div class="act--create-basic">
        <v-card class="act--create-card">
          <p>CREATE RESOURCE</p>
          <v-form v-model="valid">
            <div class="act--create-pd">
              <v-text-field v-model="name" label="NAME" :rules="nameRules" />
            </div>
              <v-btn color="primary" :disabled="!valid" large block depressed @click="createResource">Save</v-btn>
          </v-form>
        </v-card>
      </div>
  </section>
</template>

<script>
import { coreClient } from "../../../apollo.js";
import gql from "graphql-tag";

export default {
  name: "CreateResource",
  data() {
    return {
      name: "",
      valid: false,
      nameRules: [
        v => !!v || "The name wasn't found.",
        v => v.length > 2 || "The name must be longer than 2 characters."
      ],
      err: "",
      snackbar: {
        show: false,
        text: "",
        color: ""
      }
    };
  },
  methods: {
    async createResource() {
      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation createResource($name: String!) {
              createResource(name: $name) {
                id
                name
              }
            }
          `,
          variables: { name: this.name }
        });

        this.snackbar = {
          show: true,
          text: "The Resource was created successfully.",
          color: "success"
        };

        setTimeout(() => {
          this.$router.push(
            "/authentication/resource/" + data.createResource.id
          );
        }, 700);
      } catch (e) {
        this.snackbar = {
          show: true,
          text:
            e.graphQLErrors.length > 0
              ? e.graphQLErrors[0].data.message
              : e.message,
          color: "error"
        };
        this.err = e;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '../../../assets/stylus/Activities_create.styl';
</style>
